// @flow

import type {FolderType} from 'app/folders/types';
import {taskDispatcher} from 'app/subscriptions/taskDispatcher';
import {postJson} from 'app/utils/request';
import {IMPORTDOC_API_URL} from 'app/urls';
import {type ImportableDocsContentType} from 'app/docimport/types';
import type {TeamType} from 'app/teams/types';

export const importDocument =
  (
    key: string,
    target_content_type: ImportableDocsContentType,
    original_filename: string,
    teams: Array<TeamType>,
    folders: Array<FolderType>
  ) =>
  (dispatch: any) =>
    dispatch(
      taskDispatcher(
        postJson(IMPORTDOC_API_URL, {
          key,
          target_content_type,
          original_filename,
          teams: teams.map((team) => team.url),
          folders: folders.map((folder) => folder.url),
        })
      )
    );
